import { IController } from 'angular';
import { filter, orderBy, remove } from 'lodash';
import { NotificationMessageParser } from '../../../../ng2/shared/services/notification-message-parser/notification-message-parser.service';
import { INotification } from '../../../../ng2/shared/typings/interfaces/notification.interface';

interface IDisplayNotification extends INotification {
  canBeDismissed: boolean;
}

export class NotificationsCtrl implements IController {
  static $inject: string[] = ['NotificationMessageParser', '$mdMedia', 'ToggleService'];

  // bindings
  public currentUser;
  public notifications;

  // ctrl props
  public displayedNotifications;
  public toggleText;
  public notificationMessages = {};

  constructor(
    private notificationMessageParser: NotificationMessageParser,
    private $mdMedia, // used in template (CM)
  ) {}

  public $onInit(): void {
    if (this.notifications) this.loadNotifications(this.notifications);
  }

  private loadNotifications(notifications): void {
    this.notifications = filter(notifications, (notification: IDisplayNotification) => {
      this.notificationMessages[notification._id] = this.notificationMessageParser.parseMessage(notification.message);

      notification.canBeDismissed = this.isDismissable(notification);

      const isAlert = notification.type === 'ALERT';
      const isDismissed = notification.dismissals[this.currentUser._id];

      if (isAlert && !isDismissed) {
        return notification;
      }
    });

    this.displayedNotifications = this.sortNotifications().slice(0, 2);
    this.toggleText = `${this.notifications.length - 2} more notifications` || null;
  }

  public isDismissable(item): boolean {
    const isDismissed = item.dismissals[this.currentUser._id];
    const canBeDismissed = item.isDismissable && !isDismissed;
    return canBeDismissed;
  }

  private sortNotifications() {
    return orderBy(this.notifications, ['priority', 'endsOn']);
  }

  public dismissNotification(notification): void {
    // current users id exists as a key, regardless of value
    if (notification.dismissals[this.currentUser._id] === true) {
      // should not enter this condition at all, button should be disable
      console.warn(`${this.currentUser._id} has already notification has already been acknowledged by user`);
    } else if (notification.isDismissable) {
      notification.dismiss(this.currentUser._id).then(res => {
        notification.dismissals[this.currentUser._id] = true;

        // need to remove both from original set as well as what is currently displayed
        remove(this.displayedNotifications, (n: any) => {
          return n._id === res.data._id;
        });

        remove(this.notifications, (n: any) => {
          return n._id === res.data._id;
        });

        if (this.displayedNotifications.length < 2) this.displayedNotifications = this.notifications;

        return res;
      });
    }
  }

  public toggleDisplayedNotifications(): void {
    // if there were 5 originally but what is currently displayed is not 5
    if (this.displayedNotifications.length !== this.notifications.length) {
      this.displayedNotifications = this.sortNotifications();
      this.toggleText = 'Show Less';
    } else {
      this.displayedNotifications = this.sortNotifications().slice(0, 2);
      this.toggleText = `${this.notifications.length - 2} more notifications`;
    }
  }
}
